import { useCallback } from 'react'

import { type Entity } from '../../components/elements/Select/select-types'

export const useSelectExcludeNotExistValues = <T extends Entity, V>(
  targets: T[] | undefined,
  handleChange?: (value: V | V[] | null, option: T | T[] | null) => void,
  isEqual: (value: V, target: T) => boolean = (value, target) =>
    value === target.id
) => {
  return useCallback(
    (value: V | V[] | null | undefined) => {
      if (!targets) {
        // 選択対象が未確定の場合には除外判定ができないので何もしない
        return value
      }

      if (!value) {
        // falsy な値は null で返す
        return null
      }
      if (Array.isArray(value) && value.length === 0) {
        return value
      }

      if (Array.isArray(value)) {
        const filterd = value.filter((v) => targets?.some((t) => isEqual(v, t)))
        if (value.length != filterd.length) {
          handleChange?.(
            filterd,
            targets?.filter((t) => filterd.some((v) => isEqual(v, t))) ?? []
          )
          return filterd
        }
        return value
      }

      if (!targets?.find((t) => isEqual(value, t))) {
        handleChange?.(null, null)
        return null
      }

      return value
    },
    [targets, handleChange, isEqual]
  )
}
